import { styled } from '@mui/system';
import { Popover as PopoverMui } from '@mui/material';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
  height: 100%;
`;

export const Title = styled('div')`
  font-weight: 700;
  font-size: 16px;
  color: ${theme.palette.text.dark};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .date {
    font-weight: 400;
    font-size: 12px;
    color: ${theme.palette.secondary.main};
  }
`;

export const Calendar = styled('div')`
  width: 100%;
  max-width: 500px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`;

export const CalendarRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Day = styled('div')`
  width: 36px;
  height: 36px;
  font-size: 13px;
  color: ${theme.palette.secondary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  opacity: 0.7;
  cursor: default;

  &:hover {
    box-shadow: 0 0 1px 1px ${theme.palette.secondary.main}70;
  }

  &.weekName {
    font-weight: 700;
    font-size: 12px;

    &:hover {
      box-shadow: none;
    }
  }

  &.currentMonth {
    color: ${theme.palette.text.dark};
    opacity: 1;
  }

  &.hasEvents {
    background: ${theme.palette.primary.main}40;
    cursor: pointer;
  }

  &.today {
    background: ${theme.palette.primary.main};
    color: ${theme.palette.buttonText.contrast};
  }
`;

export const Popover = styled(PopoverMui)`
  .MuiPaper-root {
    padding: 0;
  }
`;

export const DropdownContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 6px;
  width: 350px;
  padding: 20px 16px;
  font-size: 14px;
`;

export const PopoverTitle = styled('div')`
  font-weight: 700;
  color: ${theme.palette.text.dark};
  margin-bottom: 8px;
`;

export const PopoverDate = styled('div')`
  color: ${theme.palette.secondary.main};
`;

export const PopoverDivider = styled('div')`
  background: ${theme.palette.background.default};
  height: 1px;
  width: 100%;
  margin: 10px 0;
`;

export const PopoverEvent = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  color: ${theme.palette.secondary.main};
  white-space: nowrap;
  padding: 3px 0;

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price {
    font-weight: 700;
  }
`;
